import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomPaginatorIntlService extends MatPaginatorIntl {
  private destroy$ = new Subject<void>();

  constructor(private translateService: TranslateService) {
    super();
    this.setupTranslations();
  }

  private setupTranslations(): void {
    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateTranslations());

    this.updateTranslations();
  }

  private updateTranslations(): void {
    this.translateService.get([
      'PAGINATOR_ITEMS_PER_PAGE',
      'PAGINATOR_NEXT_PAGE',
      'PAGINATOR_PREVIOUS_PAGE',
      'PAGINATOR_OF_LABEL',
      'PAGINATOR_FIRST_PAGE',
      'PAGINATOR_LAST_PAGE',
      'PAGINATOR_RANGE_PAGE'
    ]).subscribe(translations => {
      this.itemsPerPageLabel = translations['PAGINATOR_ITEMS_PER_PAGE'] || 'Items per page:';
      this.nextPageLabel = translations['PAGINATOR_NEXT_PAGE'] || 'Next page';
      this.previousPageLabel = translations['PAGINATOR_PREVIOUS_PAGE'] || 'Previous page';
      this.firstPageLabel = translations['PAGINATOR_FIRST_PAGE'] || 'First page';
      this.lastPageLabel = translations['PAGINATOR_LAST_PAGE'] || 'Last page';

      this.getRangeLabel = this.getRangeLabelIntl;
      this.changes.next();
    });
  }

  private getRangeLabelIntl = (page: number, pageSize: number, length: number): string => {
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return this.translateService.instant('PAGINATOR_RANGE_PAGE', {
      start: startIndex + 1,
      end: endIndex,
      length: length
    }) || `${startIndex + 1} - ${endIndex} of ${length}`;
  };

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
